(function () {
  angular
    .module('BuscaAtivaEscolar')
    .controller(
      'TwoFactorModalController',
      function TwoFactorModalController(
        $scope,
        $uibModalInstance,
        $state,
        $timeout,
        Modals,
        Auth,
        Identity,
        email,
        password
      ) {
        $scope.isVerifying = false; // Estado para verificar se está processando
        $scope.code = ''; // Inicializa o código
        $scope.resendDisabled = false;
        $scope.resendTimer = 60; // Tempo inicial em segundos

        function startResendTimer() {
          $scope.resendDisabled = true;
          $scope.resendTimer = 60;

          function countdown() {
            if ($scope.resendTimer > 0) {
              $scope.resendTimer--;
              $timeout(countdown, 1000);
            } else {
              $scope.resendDisabled = false;
            }
          }

          countdown();
        }

        function onError({ error }) {
          $scope.isVerifying = false;
          $scope.code = ''; // Limpa o código
          
          if (error == "invalid_2fa_code") {
            Modals.show(Modals.Alert('Código inválido', 'O código informado está incorreto ou expirou. Por favor, CLIQUE em "Reenviar novo código" para tentar novamente.'));
          } else {
            Modals.show(Modals.Alert('Erro desconhecido', 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Caso o problema persista, entre em contato com o suporte técnico.'));
          }

        }

        function onSubmit() {
          $uibModalInstance.dismiss();          

          if (Identity.getCurrentUser().lgpd) {
            if (!Identity.isUserType('coordenador_operacional'))
              return $state.go('dashboard');
            if (!Identity.hasTenant()) return $state.go('dashboard');
            if (!Identity.getCurrentUser().tenant.is_setup)
              return $state.go('tenant_setup');

            return $state.go('dashboard');
          } else {
            return $state.go('lgpd_signup');
          }
        }

        function onResend() {
          $scope.isVerifying = false;
          Modals.show(Modals.Alert('Código reenviado', 'Um novo código de autenticação foi enviado para o seu e-mail. Verifique sua caixa de entrada e, caso não o encontre, confira também a pasta de spam.'));
          startResendTimer();
        };

        $scope.dismiss = function () {
          if (!$scope.isVerifying) {
            $uibModalInstance.dismiss();
          }
        };

        // Atualiza o valor do código e chama a função send se atingir 6 dígitos
        $scope.updateCode = function () {
          // Remove caracteres que não sejam números
          $scope.code = $scope.code.replace(/\D/g, '');

          // Verifica se o código possui 6 dígitos
          if ($scope.code.length === 6) {
            $scope.send(); // Chama a função send
          }
        };

        $scope.resend = function () {
          if ($scope.isVerifying || $scope.resendDisabled) return; // Previne múltiplos envios
          $scope.isVerifying = true; // Ativa o estado de verificação
          
          Auth.sendTwoFactorCode(email, password).then(onResend, onError);
        };

        $scope.send = function () {
          if ($scope.isVerifying) return; // Previne múltiplos envios
          $scope.isVerifying = true; // Ativa o estado de verificação
          
          Auth.login(email, password, $scope.code).then(onSubmit, onError);
        };

        // Inicia o timer assim que o modal for carregado
        startResendTimer();

      }
    );
})();
